import { render, staticRenderFns } from "./EditGate.vue?vue&type=template&id=28e002ac&scoped=true&"
import script from "./EditGate.vue?vue&type=script&lang=js&"
export * from "./EditGate.vue?vue&type=script&lang=js&"
import style0 from "./EditGate.vue?vue&type=style&index=0&id=28e002ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e002ac",
  null
  
)

export default component.exports